import React from 'react';
import { Handle, Position } from 'reactflow';
import Button from '../../../../components/Button/Button';

interface SlotButtonProps {
  text: string;
  handleId: string;
  onClick?: (event: React.MouseEvent) => void;
  isConnectable: boolean;
  className?: string;
  isHighlighted?: boolean;
}

function SlotButton({
  text,
  handleId,
  onClick,
  isConnectable,
  className = 'p-3 border rounded-md bg-gray-50 cursor-pointer hover:bg-gray-100 transition-colors text-sm w-full justify-start text-left',
  isHighlighted = false
}: Readonly<SlotButtonProps>): React.ReactElement {
  const highlightClass = isHighlighted
    ? 'ring-2 ring-blue-500 shadow-[0_0_10px_rgba(59,130,246,0.5)]'
    : '';

  return (
    <div className='mb-2 relative'>
      <Button
        variant='outline'
        className={`${className} ${highlightClass}`}
        onClick={onClick}
      >
        {text}
      </Button>
      <Handle
        type='source'
        position={Position.Right}
        id={handleId}
        style={{ right: -26 }}
        isConnectable={isConnectable}
      />
    </div>
  );
}

export default SlotButton;
